export default __webpack_public_path__ + "static/media/M_143_A.201a1200.jpg";